import { CruiseModel } from 'api-hooks/cruise';
import React from 'react';

import { CruiseFormType } from '../components/form-type';

export default function useCruiseDefaultValues(cruise?: CruiseModel) {
  const defaultValues = React.useMemo<CruiseFormType>(() => {
    return {
      code: cruise?.code || '',
      name: cruise?.name || '',
      email: cruise?.email || '',
      phone: cruise?.phone || '',
      phone_2: cruise?.phone_2 || '',
      cruiseRooms: cruise?.cruiseRooms || [
        { size: '', type: '', description: '' },
      ],
      contact: {
        id: cruise?.contact?.id,
        name: cruise?.contact?.name || '',
        email: cruise?.contact?.email || '',
        phone: cruise?.contact?.phone || '',
        description: cruise?.contact?.description || '',
      },
      cruiseShips: cruise?.cruiseShips.length
        ? cruise?.cruiseShips
        : [{ name: '' }],
    };
  }, [cruise]);

  return defaultValues;
}
